export const blockIconsTravelLuggageNew = (
	<span className='material-symbols-outlined'>luggage</span>
);
